import React, { ReactNode, useState } from "react";
import { Card, Button, Collapse } from "antd";
import s from "./CollapsedCard.less";

interface ICollapsedCard {
  cardTitle?: string;
  cardContent: ReactNode;

  collapsedCardTitle?: string;
  collapsedCardContent: ReactNode;

  disabledCollapse?: boolean;
}

export const CollapsedCard = ({
  cardTitle,
  cardContent,
  collapsedCardTitle,
  collapsedCardContent,
  disabledCollapse,
}: ICollapsedCard) => {
  const [isDetailsVisible, setIsDetailsVisible] = useState(false);

  return (
    <Card
      className={s.container}
      classNames={{
        body: s.cardBody,
      }}
    >
      {cardTitle && <span className={s.title}>{cardTitle}</span>}
      {cardContent}

      {!disabledCollapse && (
        <Collapse activeKey={isDetailsVisible ? ["details"] : []} ghost>
          <Collapse.Panel
            key="details"
            header={null}
            showArrow={false}
            className={s.collapse}
          >
            <div className={s.delimiter} />

            <Card
              className={s.container}
              classNames={{
                body: s.innerCardBody,
              }}
            >
              {collapsedCardTitle && (
                <span className={s.title}>{collapsedCardTitle}</span>
              )}
              {collapsedCardContent}
            </Card>
          </Collapse.Panel>
        </Collapse>
      )}

      {!disabledCollapse && (
        <Button
          type="link"
          className={s.button}
          onClick={() => setIsDetailsVisible(!isDetailsVisible)}
        >
          {isDetailsVisible ? "Скрыть" : "Показать"}
        </Button>
      )}
    </Card>
  );
};
